module.exports = __webpack_public_path__ + "img/product28804p.79593915.png";